export class AddPatentPayment {
    solicitudePerson: string;
    solicitudeDate: string;

    constructor(other?: AddPatentPayment) {
        if (other) {
            this.solicitudePerson = other.solicitudePerson;
            this.solicitudeDate = other.solicitudeDate;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/AddPatentPayment.ts
 **/